export default {
	roleFullstackAndCoFounder: 'Software Engineer, Co-Founder',
	roleFullstack: 'Software Engineer',
	roleUIUXDesigner: 'UI/UX Designer'
}
